import DeliveryPeriod from "domain/deliveryPeriod";
import ExternalHttpClient from "../../common/externalHttpClient";

export interface IExternalBidsService {
    listDeliveryPeriods(authKey: string, commodityIds: number[], locationIds: string[]): Promise<DeliveryPeriod[]>;
}

class ExternalBidsService implements IExternalBidsService {

    async listDeliveryPeriods(authKey: string, commodityIds: number[], locationIds: string[]): Promise<DeliveryPeriod[]> {
        const response = await ExternalHttpClient.getClient(authKey)
            .get<{deliveryPeriods: DeliveryPeriod[]}>('/settings/v2/delivery-periods', {
            params: {
                commodityIds: commodityIds?.join(','),
                locationIds: locationIds?.join(',')
            }
        });
        return response.data.deliveryPeriods;
    }

}

const externalBidsService: IExternalBidsService = new ExternalBidsService();

export default externalBidsService;